<div class="container">
  <!-- Filter -->
  <mat-form-field appearance="legacy" class="margin-top-1 search">
    <mat-label>{{ "search" | translate }}</mat-label>
    <input
      matInput
      class="form-control"
      [formControl]="searchCtrl"
      name="filter-chat"
      autocomplete="false"
    />
  </mat-form-field>

  <!--Chats-->
  <div
    *ngFor="let chat of filteredChats | async; last as last"
    class="padding-top-1"
    id="chat-card"
    (click)="onChatClicked(chat)"
    [class.chat-selected]="chatSelected === chat.user_id"
  >
    <div class="chat-row">
      <div class="chat-column-1 margin-right-1" style="position: relative;">
        <img class="chat-icon" [src]="chat.user_photo" appErrorImage />
        <div *ngIf="chat.is_online" class="mt-4 online-point" style="" title="En línea .."></div>
      </div>
      <div class="chat-column-2">
        <div class="flex-space-between">
          <!-- Group 2 -->
          <div>
            <span class="ellipsis mat-h4">
              {{ chat.name }}
                
            </span>
          </div>
          <!-- Group 2 -->
          <div class="mat-caption">
            <span class="badge badge-danger" *ngIf="chat.count > 0">{{chat.count}}</span>
            {{ chat.last_message?.date_human_readable }}
          </div>
        </div>
        <div class="mat-caption last-message ellipsis">
          {{ chat.last_message?.content }}
        </div>
      </div>
    </div>

    <mat-divider class="margin-top-1"></mat-divider>
  </div>
</div>
